import { toUpper } from 'lodash';

export * from './AccountGroupRole';
export * from './BehaviorCompletionSource';
export * from './CIBPageName';
export * from './ClosedProgramSpendCorrectionOutcome';
export * from './Country';
export * from './DeliverableTemplateType';
export * from './Errors';
export * from './ErrorType';
export * from './FarmerReprocessingScope';
export * from './FarmerReprocessingSource';
export * from './FeatureFlag';
export * from './GrainTransactionImportType';
export * from './GrowersContactInfo';
export * from './ImportMappingType';
export * from './ImportStatus';
export * from './ImportType';
export * from './IntegrationSyncStatus';
export * from './IntegrationSyncType';
export * from './IntegrationType';
export * from './NotificationType';
export * from './OrderTransactionSubtype';
export * from './OrderTransactionStatus';
export * from './OrderTransactionType';
export * from './OrderTransactionProductType';
export * from './PackageType';
export * from './PointsAudit';
export * from './PointsHistoryClassification';
export * from './ProgramMembership';
export * from './ProductExclusionType';
export * from './QueryFilter';
export * from './Report';
export * from './RewardsProgramType';
export * from './RewardsType';
export * from './SponsorType';
export * from './State';
export * from './TransactionType';
export * from './UnitOfMeasures';
export * from './UserPermissions';
export * from './UserType';
export * from './Churn';
// putting this down at the bottom due to some possible circular dependency issue
export * from './RewardsUom';

export function parseEnum (dataEnum: object, input: string | number | null | undefined) {
  if (!input) {
    return undefined;
  }

  const match = Object.values(dataEnum).find(
    (value) => (typeof value === 'string' ? toUpper(value) : value)
      === (typeof input === 'string' ? toUpper(input) : input),
  );
  return (match || undefined);
}

export function parseEnums (dataEnums: object[], input: string | number | null | undefined) {
  for (const dataEnum of dataEnums) {
    const parsedValue = parseEnum(dataEnum, input);
    if (parsedValue) { return parsedValue; }
  }

  return undefined;
}
/**
 * Throw error if value received does not match a known enum
 * @param dataEnums
 * @param errMessage
 */
export function validateEnum (dataEnums: object | object[], errMessage: string) {
  return {
    fn: (value: unknown) => {
      const validValues = Array.isArray(dataEnums)
        ? dataEnums.map((dataEnum) => Object.values(dataEnum)).flat()
        : Object.values(dataEnums);
      if (!validValues.includes(value)) {
        throw new Error(`${errMessage}: ${value}`);
      }
    },
  };
}
export { FarmerTierHistoryType } from './FarmerTierHistoryType';
